<mat-form-field class="example-full-width" appearance="outline" color="accent">
  <mat-label>{{ label() }}</mat-label>
  <input
    class="building-address-input"
    type="text"
    matInput
    #employeeInput
    [matAutocomplete]="auto"
    (keyup)="autoComplete($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onSelectionChange($event.option.value)"
    [displayWith]="formatEmployee"
  >
    @for (employee of searchResults; track $index) {
      <mat-option [value]="employee">
        <div>
          <svg [size]="14" lucideTag></svg>
          <strong>{{ employee.firstname }} {{ employee.lastname }}</strong>
        </div>
        <div class="indent"><svg [size]="14" lucideAtSign></svg>{{ employee.email }}</div>
        <div class="indent">
          <span class="phone">
            <svg [size]="14" lucidePhone></svg>
            {{ employee.phoneNumber | phoneNumber }}
          </span>
          <span>
            <svg [size]="16" lucideIdCard></svg>{{ employee.socialSecurityNumber | formatSsn }}
          </span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>

  <button
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="clear()"
    matTooltip="Effacer la saisie"
  >
    <mat-icon>delete_sweep</mat-icon>
  </button>
  @if (showHint()) {
    <mat-hint
      >Vous pouvez rechercher nom, prénom, numéro de téléphone, de sécurité sociale ou email.<br />
      L'ordre des mots n'a pas d'importance, ni les majuscules/minuscules ou accents.<br />
      Seuls les employés avec un numéro de sécurité sociale fixe seront affichés.
    </mat-hint>
  }
</mat-form-field>
